import { render, staticRenderFns } from "./Sokoban.vue?vue&type=template&id=19a0a72c&lang=pug"
import script from "./Sokoban.vue?vue&type=script&lang=js"
export * from "./Sokoban.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports